import DepartureDateSidePanelContent from "app/pages/SmartDP/Search/DepartureDateSidePanelContent/DepartureDateSidePanelContent";
import CalendarDisabledView from "app/pages/SmartDP/Search/SDPSearchForm/CalendarDisabledView";
import { FormattedMessage, useIntl } from "react-intl";
import { TravelDatesSelection } from "../../types";

type TravelDatesCalendarProps = {
	value?: TravelDatesSelection;
	hasRequiredData?: boolean;
	hasNoDates?: boolean;
	onChange?: (value: TravelDatesSelection) => void;
	onConfirm?: (value: TravelDatesSelection) => void;
	minDate?: number;
	maxDate?: number;
	isLoading?: boolean;
	isDateDisabled: (date?: string | Date | number) => boolean;
};

export const TravelDatesCalendar = ({
	value,
	hasRequiredData = false,
	hasNoDates = false,
	onChange = () => {},
	onConfirm = () => {},
	minDate,
	maxDate,
	isLoading = false,
	isDateDisabled,
}: TravelDatesCalendarProps) => {
	const { formatMessage } = useIntl();

	const departureDate = value && value.departureDate;
	const endDate = value && value.endDate;

	let calendarDisabledView = null;

	if (hasRequiredData && hasNoDates) {
		calendarDisabledView = (
			<CalendarDisabledView
				mainMessage={formatMessage({
					id: "sdp.calendar.unavailable.date.label",
				})}
				secondaryMessage={formatMessage({
					id: "sdp.calendar.unavailable.date.sublabel",
				})}
			/>
		);
	} else if (!hasRequiredData) {
		calendarDisabledView = (
			<CalendarDisabledView
				mainMessage={formatMessage({
					id: "sdp.calendar.no.destination.no.departure.city.label",
				})}
			/>
		);
	}

	return (
		<DepartureDateSidePanelContent
			initialDate={[departureDate, endDate]}
			onDateSelect={date => {
				onChange({
					departureDate: date[0],
					endDate: date[1],
				});
			}}
			onDateConfirm={date => {
				onConfirm({
					departureDate: date[0],
					endDate: date[1],
				});
			}}
			departureDateMin={minDate}
			departureDateMax={maxDate}
			checkDateAvailability={isDateDisabled}
			isCalendarLoading={isLoading}
			calendarDisabledView={calendarDisabledView}
			displayCalendarIcon={true}
			departureDateLabel={
				<FormattedMessage id="sdp.search.departure.date.side.panel.title" />
			}
			returnDateLabel={<FormattedMessage id="sdp.search.destination.date.side.panel.title" />}
		/>
	);
};
